<template>
  <div class="vertical-align-wrap">
    <div
      class="vertical-align-middle auth-main d-flex h-100"
      style="background-color: oklch(98.4% 0.003 247.858)"
    >
      <div class="d-flex align-items-center justify-content-center w-100">
        <div class="auth-box">
          <div class="top d-flex justify-content-center my-2">
            <img
              src="../../../assets/logo6.png"
              alt="Lucid"
              style="width: 50px"
            />
            <link
              href="https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap"
              rel="stylesheet"
            />
            <span
              style="
                margin-top: 19px;
                margin-left: -9px;
                color: #273061;
                display: inline-block;
                font-family: 'Lato', sans-serif;
                font-size: 20px;
              "
              >FaceScreen</span
            >
          </div>
          <div class="card shadow-lg">
            <div class="header justify-content-center p-0 mt-3">
              <p class="lead text-center">Reset password</p>
            </div>
            <div class="body">
              <p class="text-center" style="opacity: 0.7">
                Please enter your new password.
              </p>
              <form class="form-auth-small" v-on:submit.prevent="submit">
                <div class="form-group">
                  <label for="signup-password" class="control-label mt-2"
                    >Password</label
                  >
                  <input
                    type="password"
                    class="form-control"
                    id="signup-password"
                    v-model="password"
                    placeholder="Create a Password"
                    required
                    @input="validatePassword"
                    @focus="passwordFocused = true"
                    @blur="passwordFocused = false"
                  />
                </div>

                <div
                  v-if="passwordFocused"
                  class="password-requirements mt-2 mb-1"
                >
                  <p :class="{ valid: isLengthValid }">
                    ✔️ At least 10 characters
                  </p>
                  <p :class="{ valid: hasUppercase }">
                    ✔️ At least one uppercase letter
                  </p>
                  <p :class="{ valid: hasNumber }">✔️ At least one number</p>
                  <p :class="{ valid: hasSpecialChar }">
                    ✔️ At least one special character (@, !, %, etc)
                  </p>
                </div>

                <div class="form-group">
                  <label for="confirm-password" class="control-label mt-1"
                    >Confirm Password</label
                  >
                  <input
                    type="password"
                    class="form-control"
                    id="confirm-password"
                    v-model="confirmPassword"
                    placeholder="Re-enter Your Password"
                    required
                  />
                </div>
                <button type="submit" class="btn btn-primary btn-lg btn-block">
                  RESET PASSWORD
                </button>
                <div
                  v-if="statusMessage.show"
                  :class="[
                    'alert px-1 py-2 ml-0',
                    statusMessage.isError ? 'alert-danger' : 'alert-success',
                  ]"
                  style="margin-top: 15px"
                >
                  <i
                    :class="statusMessage.icon_class"
                    v-if="!statusMessage.isError"
                  ></i>
                  {{ statusMessage.text }}
                </div>
                <div class="bottom">
                  <span class="helper-text"
                    >Know your password?
                    <router-link to="/authentication/page-login"
                      >Login</router-link
                    ></span
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-logos">
      <img
        v-for="(logo, i) in footerLogos"
        :key="i"
        :src="logo"
        :alt="`logo-${i + 1}`"
        :class="[
          'footer-logo',
          {
            'footer-logo-large': i === 2,
            'footer-logo-shift': i === 0 || i === 1,
          },
        ]"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ResetPasswordComponent",
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordFocused: false,
      isLengthValid: false,
      hasUppercase: false,
      hasNumber: false,
      hasSpecialChar: false,
      statusMessage: {
        show: false,
        text: "",
        isError: false,
        icon_class: "",
      },
      token: "",
      footerLogos: [
        require("@/assets/Picture1.jpg"),
        require("@/assets/Picture2.png"),
        require("@/assets/Picture3.png"),
      ],
    };
  },

  methods: {
    validatePassword() {
      this.isLengthValid = this.password.length >= 10;
      this.hasUppercase = /[A-Z]/.test(this.password);
      this.hasNumber = /\d/.test(this.password);
      this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
    },

    async submit() {
      this.validatePassword();

      // Check if password requirements are met
      if (
        !this.isLengthValid ||
        !this.hasUppercase ||
        !this.hasNumber ||
        !this.hasSpecialChar
      ) {
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title:
            "Password must meet all the requirements before submitting.",
          show: true,
        };
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.statusMessage = {
          show: true,
          text: "Passwords do not match!",
          isError: true,
        };
        return;
      }

      try {
        const token = this.$route.query.token;
        const fasdBackendURL = localStorage.getItem("fasdBackendURL");
        const response = await fetch(
          `${fasdBackendURL}/api/users/reset-password`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              token: token,
              new_password: this.password,
            }),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.detail || "Failed to reset password");
        }

        this.statusMessage = {
          show: true,
          class: "alert alert-success",
          icon_class: "fa fa-check-circle",
          text: result.message,
          isError: false,
        };

        setTimeout(() => {
          this.$router.push({ path: "/authentication/page-login" });
        }, 4000);
      } catch (err) {
        this.statusMessage = {
          show: true,
          text: err.message,
          isError: true,
        };
      }
    },
  },
};
</script>

<style scoped>
.alert {
  display: flex;
  align-items: flex-start;  
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  font-size: 14px;
  gap: 4px;
  width: 100%;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  display: flex;
  align-items: center;
}

.alert-success .fa,
.alert-success i {
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-danger .fa,
.alert-danger i {
  color: #721c24;
}

.password-requirements p {
  margin: 0;
  font-size: 13px;
  color: #999;
}
.password-requirements p.valid {
  color: #28a745;
  font-weight: bold;
}
.footer-logos {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}
.footer-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
}
.footer-logo-large {
  height: 70px;
}
.footer-logo-shift {
  margin-top: 10px;
}
</style>
